import { useEffect, useState } from "react";
import { PosterInfo } from "../types/snapshot";
import { getPosterInfo } from "../api";

interface UsePosterInfoProps {
  course_no: string;
  page_id: number;
}

const usePosterInfo = (params: UsePosterInfoProps) => {
  const [poster, setPoster] = useState<PosterInfo>();

  useEffect(() => {
    getPosterInfo(params).then((data) => setPoster(data));
  }, [params]);

  return poster;
}

export default usePosterInfo;
